import CybsTab from '@cybs-ui/components/lib/tab';
import React from 'react';
import { connect } from 'react-redux';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import { getHasQueryParams, getLiveConsoleTabIndex } from '../../../reducers/rhs-schema-reducer';
import { getDevCenterDataStore } from '../../../../../app/store';
import { headerLevelHandleSelection } from '../js/live-console';
import CircularProgress from '@material-ui/core/CircularProgress';

import BodyTabInLiveConsole from '../js/body-tab-in-live-console';
import ColumnDivider from '../js/column-divider';
import CustomHeaders from '../js/custom-request-header';
import DescriptionInLiveConsole from '../js/description-in-live-console';
import ExpandedDescriptions from '../js/expanded-descriptions';
import QueryParamsTabInLiveConsole from '../js/query-params-in-live-console';
import $ from 'jquery';
import CybsCard from '@cybs-ui/components/lib/card';
import RequestHeader from '../js/request-header';
import ResetFunctionalityInLiveConsole from '../js/reset-funtionality-in-live-console';
import ReturnToLiveConsole from '../js/return-to-live-console';
import SampleCodeDropDownInLiveConsole from '../js/sample-code-dropdown';
import SampleCodeEditor from '../js/sample-code-editor';
import SampleRequestDropDownInLiveConsole from '../js/sample-request-dropdown';
import UrlEditorInLiveConsole from '../js/url-editor-in-live-console';
import ViewOnGitHubLink from '../js/view-on-github';
import { getLanguageDetails, isDefaultSite, setJsTreePath } from '../../../../../commons/ui-commons';
import SendButtonInLiveConsoleTab from '../js/send-download-button';
import { getHasBodyParams } from '../../../../../lhs/reducers/lhs-reducer';
import PaymentProcessorListing from './payment-processor-listing';



/**
 * Request description in live console tab 
 */
var tabs = [];
var selectedSampleCode = "";
var exampleValue = "";
var exampleData = "";
var liveConsoleTabIndex = getLiveConsoleTabIndex();
var languages = getLanguageDetails();
var hasBodyParams = getHasBodyParams();
var hasQueryParams = getHasQueryParams();

function getLanguageById(languageArray, id) {
    for (var index in languageArray) {
        if (languageArray[index]['value'] == id) {
            return languageArray[index]['label'];
        }
    }
}

function getHeadingValue(languageDetails) {
    if (languageDetails == "Live Console") {
        return "Request";

    }
    else {
        return "Sample Code";
    }
}
class LiveConsoleTabIndex extends React.Component {

    queryParamChecker = getDevCenterDataStore().subscribe(() => {

        if (liveConsoleTabIndex == 2 && tabs.length == 3 && hasQueryParams == true) {
            this.setState({ comment: 'Force render for Query Params two-way binding' });
        }

    });
    refresh = () => {
        // re-renders the component
        this.setState({});
      };
    render() {

        exampleValue = (this.props.exampleValue == undefined) ? "" : this.props.exampleValue;
        hasBodyParams = (this.props.hasBodyParams == undefined) ? false : this.props.hasBodyParams;
        hasQueryParams = (this.props.hasQueryParams == undefined) ? false : this.props.hasQueryParams;
        liveConsoleTabIndex = (this.props.liveConsoleTabIndex == undefined) ? 0 : this.props.liveConsoleTabIndex;
        selectedSampleCode = (this.props.selectedSampleCode == undefined) ? {
            'label': 'Live Console',
            'value': 'Live Console'
        } : this.props.selectedSampleCode;

        var sendButtonController;
        sendButtonController = <SendButtonInLiveConsoleTab />

        tabs = [
            {
                label: 'Body',
                dataTest: "request-body-tab",
                children: (
                    <div>
                        <CircularProgress class="BodyTabLoaderIndicator" id="BodyTabLoaderIndicator"/>
                        <BodyTabInLiveConsole />
                    </div>
                ),
                disabled: !hasBodyParams
            },

            {
                label: 'Headers',
                dataTest: "request-headers-tab",
                children: (
                    <div id="headersTab" style={{ paddingLeft: 16 }}>
                        <RequestHeader />
                        <CustomHeaders />
                    </div>
                )
            },
            {
                label: 'Query Parameters',
                dataTest: "request-query-parameters-tab",
                children: (
                    <div>
                        <QueryParamsTabInLiveConsole />
                    </div>
                ),
                disabled: !hasQueryParams

            },
            {
                label: 'Descriptions',
                dataTest: "request-descriptions-tab",
                children: (
                    <div>
                        <DescriptionInLiveConsole />
                    </div>
                )
            }
        ];


        var sampleRequestDropDown = <div></div>;

        if (exampleValue != "" && this.props.exampleData != undefined) {
            sampleRequestDropDown = <SampleRequestDropDownInLiveConsole />

        }
        else {
            $("#headersTab").removeClass();
            $("#headersTab").addClass("getHeader");
            if (hasQueryParams) {
                $("div[aria-labelledby^='panel-Query']").removeClass();
                $("div[aria-labelledby^='panel-Query']").addClass("getHeader");
            }
        }
        if (!hasQueryParams) {
            tabs.splice(2, 1);
        }

        if (this.props.isHeadersTabHidden) {
            tabs.splice(1, 1);
        }

        if (!hasBodyParams) {
            tabs.splice(0, 1);
        }

        if (tabs.length <= liveConsoleTabIndex) {
            putDataInDevCenterDataStore({ type: 'UPDATE_LIVE_CONSOLE_TAB_INDEX', liveConsoleTabIndex: 0 });
        }
        var requestBuilderCard = $("div[data-test^='live-console-container-sample-code']")
        let resizeObserver = new ResizeObserver(() => {
            var height;
            var sampleCodeCard = document.querySelector("div[data-test^='live-console-container-sample-code']");
            if(sampleCodeCard){
                height = sampleCodeCard.offsetHeight;
            }
            var jsTreeCard = document.getElementById("jsTreeContent");
            if(jsTreeCard && sampleCodeCard){
                jsTreeCard.style.maxHeight = (height-60) + "px";
            }
            if(document.querySelector("#LiveConsole div[data-test^='payment-info-with-button']") && sampleCodeCard){
                document.querySelector("#LiveConsole div[data-test^='payment-info-with-button']").style.maxHeight = (height-143) + "px";
            }
        });
        if(requestBuilderCard.length){
           resizeObserver.observe(requestBuilderCard[0]);
        }
        if(!isDefaultSite())
        {
            $('.api-reference .vds-state--selected').addClass('border_color_theme_primary_bottom');
        }
        else{
            $('.api-reference .vds-state--selected').css('border-bottom','3px solid #2defe0 !important');
        }
        return (
          <CybsCard
            dataTest="live-console-container-sample-code"
            colorScheme="primary"
            header={
              <div>
                <div
                  class="liveConsoleHeaderTab"
                  style={{ display: "flex", height: "57px" }}
                >
                  <div
                    id="liveConsoleHeading"
                    class="liveConsoleHeading"
                    style={{
                      marginTop: "20px",
                      marginLeft: "15px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      minWidth: "150px",
                    }}
                  >
                    {getHeadingValue(selectedSampleCode["value"])}:{" "}
                    {getLanguageById(languages, selectedSampleCode["value"])}
                  </div>

                  <ReturnToLiveConsole />
                  <SampleCodeDropDownInLiveConsole />
                </div>
                <div id="config-data">
                  <ColumnDivider />
                  <ul style={{ paddingLeft: "0px", marginBlockEnd: "10px" }}>
                    <UrlEditorInLiveConsole />
                    {sampleRequestDropDown}
                    {"boolean" === typeof this.props.disableProcessorDropDown &&
                    this.props.disableProcessorDropDown ? (
                      <li></li>
                    ) : (
                      <PaymentProcessorListing />
                    )}
                  </ul>
                </div>
                <ColumnDivider />

                <div
                  id="live-console-tabs"
                  onClick={this.refresh}
                  style={{ width: "100%" }}
                >
                  <CybsTab
                    headingLevel={3}
                    selectedTab={liveConsoleTabIndex}
                    onSelectTab={(e, index) =>
                      headerLevelHandleSelection(e, index)
                    }
                    dataTest="heading-level-tabs-live-console"
                    tag="button"
                    // isUnderlined
                    tabs={tabs}
                  />
                </div>
                <div
                  id="sample-code"
                  style={{
                    display: "none",
                    width: "100%",
                    marginBottom: "5px",
                  }}
                >
                  <SampleCodeEditor />
                </div>
              </div>
            }
            footer={
              <div id="footer" class="live-console-footer">
                {tabs.length > liveConsoleTabIndex &&
                  tabs[liveConsoleTabIndex].label != "Descriptions" &&
                  selectedSampleCode["value"] === "Live Console" &&
                  sendButtonController}
                {tabs.length > liveConsoleTabIndex &&
                  tabs[liveConsoleTabIndex].label != "Descriptions" &&
                  selectedSampleCode["value"] === "Live Console" && (
                    <ResetFunctionalityInLiveConsole />
                  )}
                {tabs.length > liveConsoleTabIndex &&
                  tabs[liveConsoleTabIndex].label === "Descriptions" &&
                  selectedSampleCode["value"] == "Live Console" && (
                    <ExpandedDescriptions />
                  )}
                {selectedSampleCode["value"] !== "Live Console" && (
                  <ViewOnGitHubLink />
                )}
              </div>
            }
            style={{ marginLeft: "5px", maxWidth: "50%" }}
          ></CybsCard>
        );

    }
}
function mapStateToProps(state) {
   
    if(!isDefaultSite())
    {
        $('.api-reference .vds-state--selected').addClass('border_color_theme_primary_bottom');
        $('.vds-state--selected').addClass('border_color_theme_primary_bottom');
        // console.log($('.vds-state--selected'));
        // console.log("content changed");
        $('.css-31a4rk-white-structPadding').addClass('border_color_theme_primary_left');
        $('.css-br4h6').addClass('border_color_theme_primary_left');
    }
    else
    {
        $('.api-reference .vds-state--selected').css('border-bottom', '3px solid #2defe0!important');
    }

    return {
        hasBodyParams: state.lhsReducer.hasBodyParams,
        liveConsoleTabIndex: state.rhsReducer.liveConsoleTabIndex,
        isHeadersTabHidden: state.lhsReducer.noAuth,
        selectedSampleCode: state.examplesReducer.selectedSampleCode,
        hasQueryParams: state.rhsReducer.hasQueryParams,
        exampleValue: state.examplesReducer.exampleValue,
        exampleData: state.examplesReducer.exampleKey,
        disableProcessorDropDown: state.lhsReducer.disableProcessorDropDown
    };

}

export default connect(mapStateToProps)(LiveConsoleTabIndex);